import {Component, Inject, OnDestroy, OnInit, forwardRef} from '@angular/core';
import {NotificationsService, SpinnerComponent as Spinner, IPaginationConfig, PAGINATION_CONFIG_TOKEN} from '@westjetairlines/wjesd-component-library';
import {TravelCredit} from '../shared/models/travel-credit';
import {TRAVEL_CREDIT_SERVICE_TOKEN} from '../shared/services/travel-credit.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit, OnDestroy {
  travelCredits: Array<TravelCredit> = [];
  pnr: string;
  createdFrom: string;
  createdTo: string;
  totalItems: number;
  restartPageNumbering: boolean;

  constructor(@Inject(TRAVEL_CREDIT_SERVICE_TOKEN) private travelCreditService, private notificationService: NotificationsService,
              @Inject(forwardRef(() => PAGINATION_CONFIG_TOKEN)) private pagingConfig: IPaginationConfig) { }

  ngOnInit() {
    Spinner.start();
    let self = this;
    this.restartPageNumbering = false;

    this.travelCreditService.getAllTravelCredits(this.pagingConfig.itemsPerPage).subscribe(result => {
      if (!result.wasSuccessful) {
        this.notificationService.error(result.brokenRules[0].message);
      }

      this.setPageData(result);
    },
      err => {
        Spinner.stop();
      },
      () => {
        Spinner.stop();
      });
  }

  onSearch(firstItemNumber: number = 0) {
    Spinner.start();
    this.travelCredits = [];
    if (firstItemNumber === 0) {
      this.restartPageNumbering = true;
    }

    this.travelCreditService.getTravelCredits(this.pnr, this.createdFrom, this.createdTo, firstItemNumber, this.pagingConfig.itemsPerPage)
      .subscribe(result => {
      if (!result.wasSuccessful) {
        this.notificationService.error(result.brokenRules[0].message);
      } else {
        this.notificationService.clear();
      }

      this.setPageData(result);
    },
      err => {
        Spinner.stop();
      },
      () => {
        Spinner.stop();
      });

  }

  onPageChanged($event) {
    this.onSearch($event.firstItemNumber - 1);
  }

  ngOnDestroy(): void {
    this.notificationService.clear();
  }

  setPageData(result) {
    if (!result.wasSuccessful) {
      this.travelCredits = [];
      this.totalItems = 0;
    } else {
      this.travelCredits.push(...result.value.travelCredits);
      this.totalItems = result.value.totalItems;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts